import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import AdminLayout from '../components/AdminLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Briefcase, Search } from 'lucide-react';
import { getWorkTypeBadgeStyle, getWorkTypeLabel, formatSalary, getExpiryLabel } from '../utils/jobHelpers';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminGoJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/admin/jobs?limit=200`);
      setJobs(response.data.jobs || []);
    } catch (error) {
      toast.error('Failed to load jobs');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground mb-2">GoJobs Management</h1>
          <p className="text-muted-foreground">Manage all job listings across the platform</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>All Job Listings ({jobs.length})</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-muted/50 border-b">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-medium">Job</th>
                    <th className="px-4 py-3 text-left text-sm font-medium">Company</th>
                    <th className="px-4 py-3 text-left text-sm font-medium">Type</th>
                    <th className="px-4 py-3 text-left text-sm font-medium">Salary</th>
                    <th className="px-4 py-3 text-left text-sm font-medium">Expiry</th>
                    <th className="px-4 py-3 text-left text-sm font-medium">Apps</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="6" className="text-center py-8">Loading...</td></tr>
                  ) : jobs.length === 0 ? (
                    <tr><td colSpan="6" className="text-center py-8">No jobs found</td></tr>
                  ) : (
                    jobs.map((job) => (
                      <tr key={job.id} className="border-b hover:bg-muted/30">
                        <td className="px-4 py-3">
                          <div className="font-medium">{job.title}</div>
                          <div className="text-xs text-muted-foreground">{job.public_ref}</div>
                        </td>
                        <td className="px-4 py-3">{job.employer?.company_name || 'N/A'}</td>
                        <td className="px-4 py-3">
                          <Badge className={getWorkTypeBadgeStyle(job.employment_type)}>
                            {getWorkTypeLabel(job.employment_type)}
                          </Badge>
                        </td>
                        <td className="px-4 py-3 text-sm">
                          {job.salary_min && job.salary_max 
                            ? formatSalary(job.salary_min, job.salary_max, job.salary_unit)
                            : 'Negotiable'}
                        </td>
                        <td className="px-4 py-3 text-sm">{getExpiryLabel(job.expires_at)}</td>
                        <td className="px-4 py-3 font-semibold">{job.applications_count || 0}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
};

export default AdminGoJobs;
